import { orderBy } from '@exodus/basic-utils';
import { EXODUS_ASSET_NAME_TO_TOKEN_NAME } from '@passkeys/ui/token-icon';
import { useMemo } from 'react';

import useAssets from '@/ui/hooks/use-assets';
import useBaseAssets from '@/ui/hooks/use-base-assets';
import useEnabledAssets from '@/ui/hooks/use-enabled-assets';

function useConfigurableTokens(chains: string[]) {
  const enabledAssets = useEnabledAssets();

  const baseAssets = useBaseAssets();

  const assets = useAssets();
  const verifiedAssets = useMemo(
    () =>
      Object.keys(EXODUS_ASSET_NAME_TO_TOKEN_NAME)
        .map((assetName) => assets[assetName])
        .filter(Boolean),
    [assets],
  );

  return useMemo(() => {
    const selectedBaseAssets = baseAssets.filter((asset) =>
      chains.includes(asset.name),
    );

    const selectedEnabledAssets = Object.values(enabledAssets).filter((asset) =>
      chains.includes(asset.baseAsset.name),
    );

    const selectedVerifiedAssets = verifiedAssets.filter((asset) =>
      chains.includes(asset.baseAsset.name),
    );

    return [
      ...new Set([
        ...orderBy(selectedEnabledAssets, ['name'], ['asc']),
        ...orderBy(
          [...selectedBaseAssets, ...selectedVerifiedAssets],
          ['name'],
          ['asc'],
        ),
      ]),
    ];
  }, [baseAssets, enabledAssets, verifiedAssets, chains]);
}

export default useConfigurableTokens;
